import { render, staticRenderFns } from "./fb-warning.vue?vue&type=template&id=0b5572b6&scoped=true&"
import script from "./fb-warning.vue?vue&type=script&lang=ts&"
export * from "./fb-warning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5572b6",
  null
  
)

export default component.exports